import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService, ModalService } from '@app/core/services';
import { updateUserPreference } from '@app/core/store/actions/user.actions';
import { AppState } from '@app/core/store/reducers';
import { selectUsersState } from '@app/core/store/reducers/users.reducer';
import { User } from '@core/models';
import { Store } from '@ngrx/store';
import { MessageModalComponent } from '@shared/message-modal.component';

@Component({
  selector: 'app-user-preferences',
  templateUrl: 'user-preferences.component.html'
})
export class UserPreferencesComponent {

  user: User;
  form: FormGroup = null;
  primaryButtonText = 'Save';

  constructor(protected store: Store<AppState>, protected formBuilder: FormBuilder, protected modalService: ModalService,
    protected router: Router, protected authService: AuthService) {

    store.select(selectUsersState).subscribe(usersState => {
      this.user = usersState.user;
      if (!this.user?.allowSearch) {
        const modalRef = modalService.open(MessageModalComponent);
        const componentInstance = modalRef.componentInstance as MessageModalComponent;
        componentInstance.modalText =
          'Email preferences apply to notifications about Lab Results Searches. You do not have access to the Search feature in ' +
          'Lab Results. Please contact your Managed Care Executive or Payor Solutions Executive to get access.';
        componentInstance.title = 'Restricted Access';
        componentInstance.labelConfirm = 'Close';
        componentInstance.extraCssLinkBtn = 'invisible';
        componentInstance.dismissible = false;
        modalRef.result.then(result => {
          modalRef.close();
          if (result) {
            if (this.user.isCustomerAdmin) {
              this.router.navigate(['/portal/users']);
            } else if (this.user.isGapsInCareUser) {
              this.router.navigate(['/portal/analytic-reports/gaps-in-care']);
            } else if (this.user.isInsightAnalyticUser) {
              this.router.navigate(['/portal/analytic-reports/insight-analytics']);
            } else {
              this.router.navigate(['/portal/setup-required']);
            }
          }
        });
      }

      if (this.user) {
        this.buildForm();
      }
    });
  }

  buildForm(): void {
    this.form = this.formBuilder.group({
      sendSearchResultEmail: [this.user ? this.user.sendSearchResultEmail : false]
    });
  }

  onSave(): void {
    const formValues = this.form.getRawValue();
    let updateUser = User.userFactory(this.user);
    updateUser.sendSearchResultEmail = formValues.sendSearchResultEmail;
    this.store.dispatch(updateUserPreference({ user: updateUser }))
  }
}